import styled from '@emotion/styled';
import { tablet } from '../../../../media';

export const Main = styled.div`
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100px;

  ${tablet`
    max-width: 720px;
    margin: 0 auto;
    width: 100%;
  `}
`;

export const BottomBar = styled.div<{
  startFromZero?: boolean;
  paddingBottom?: boolean;
  transitionState?: 'idle' | 'hiding' | 'showing';
}>`
  position: fixed;
  bottom: ${(props) => (props.startFromZero ? '0px' : '46px')};
  left: 0;
  right: 0;
  background: #1e1f22;
  margin: 0px 16px;

  ${tablet`
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  `}
  padding-bottom: ${(props) => (props.startFromZero ? 'env(safe-area-inset-bottom, 0px)' : '0px')};
  border-radius: ${(props) => (props.startFromZero ? '12px 12px 0 0' : '12px')};
  border-top-width: 1px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-color: #2b2d33;
  z-index: 51;

  transform: translateY(0);
  /* Animations: hiding slides the current bar down off-screen; showing slides the new bar up from below */
  animation: ${(props) =>
    props.transitionState === 'hiding'
      ? 'slideOutDown 220ms ease forwards'
      : props.transitionState === 'showing'
        ? 'slideInUp 420ms cubic-bezier(.22,.9,.35,1)'
        : 'none'};

  /* slide out down (for initial bar) */
  @keyframes slideOutDown {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(140%);
    }
  }

  /* slide in up (for answer bar rising from bottom) */
  @keyframes slideInUp {
    0% {
      transform: translateY(140%);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* End of animations */
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 16px;
  padding: 16px 8px;
`;
